import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 30, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

// Masked word-by-word text reveal for important headings.
export function RevealText({ text, as: Tag = "h2", className = "", delay = 0 }) {
  const words = String(text).split(" ");
  return (
    <Tag className={className} aria-label={text}>
      {words.map((word, i) => (
        <motion.span
          key={`${word}-${i}`}
          className="inline-block overflow-hidden pb-[0.1em] -mb-[0.1em] align-bottom"
          aria-hidden="true"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
        >
          <motion.span
            className="inline-block will-change-transform"
            variants={{
              hidden: { y: "112%" },
              visible: {
                y: 0,
                transition: { duration: 0.85, delay: delay + i * 0.05, ease: EASE },
              },
            }}
          >
            {word}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </motion.span>
      ))}
    </Tag>
  );
}

export function SectionHeading({ eyebrow, title, description, dark = true, className = "" }) {
  return (
    <div className={`max-w-3xl ${className}`}>
      {eyebrow && (
        <Reveal>
          <span className="eyebrow">{eyebrow}</span>
        </Reveal>
      )}
      <RevealText
        text={title}
        className={`mt-5 font-display text-3xl font-bold uppercase leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl ${
          dark ? "text-ink" : "text-ink"
        }`}
      />
      {description && (
        <Reveal delay={0.15}>
          <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-slate-500" : "text-slate-700"}`}>
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
}
